import { render, staticRenderFns } from "./ExchangeRecord.vue?vue&type=template&id=e59d0ef0"
import script from "./ExchangeRecord.vue?vue&type=script&lang=js"
export * from "./ExchangeRecord.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecord.vue?vue&type=style&index=0&id=e59d0ef0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports